import React from 'react';
import type { BDirectRow } from '../../../hooks/useBDirectRows';
import { RegionDash, RegionTag } from './styles';

// Renders the `Current` column — the row's most recent Bitbucket tag.
// Non-repo rows have nothing meaningful here so they render a dash.
//
// Uses the shared `RegionTag` styled span so screen + print surfaces
// stay visually consistent with the region cells. The print page
// scopes its own table to tighten every `RegionTag` descendant into
// an inline 0.55rem label — the same component renders correctly on
// both surfaces.
export const CurrentCell: React.FC<{ row: BDirectRow }> = ({ row }) => {
  if (row.repo && row.latestTag) {
    return <RegionTag>{row.latestTag}</RegionTag>;
  }
  return <RegionDash>—</RegionDash>;
};
